<template>
  <div>
    <div class="d-flex flex-column">
      <div>
        <a target="_blank" title="Chỉnh sửa" @click="isShowEditForm = true">
          <FAIcon icon="far fa-pen-nib icon" />
        </a>
      </div>
    </div>
    <el-dialog :visible.sync="isShowEditForm" width="50%">
      <div class="title_popup text-center">
        <FAIcon icon="far fa-pen-nib" /> Chỉnh sửa thông tin cấu hình
      </div>
      <el-form ref="formPlagiarism" label-width="160px" label-position="right">
        <el-form-item label="Key">
          <el-input placeholder="Key" v-model="info.key" disabled></el-input>
        </el-form-item>

        <el-form-item label="Giá trị">
          <el-col :span="24">
            <el-input placeholder="Giá trị" v-model="value"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowEditForm = false"
          ><FAIcon icon="fas fa-times" /> Hủy bỏ</el-button
        >
        <el-button type="primary" @click="submitEditSetting"
          >Cập nhập</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiUpdateSetting } from "@/services/root_dashboard_service"
import FAIcon from "@/components/common/FAIcon.vue"

export default {
  name: "SettingEdit",
  props: ["info"],
  components: { FAIcon },
  data: function () {
    return {
      isShowEditForm: false,
      fileList: [],
      value: null,
      key: null,
    }
  },
  updated() {
    if (this.key === this.info.key) return
    this.key = this.info.key
    this.value = this.info.value
  },
  methods: {
    async submitEditSetting() {
      apiUpdateSetting(this.info.key, this.value)
        .then(() => {
          this.$message({
            message: "Chỉnh sửa thành công",
            type: "success",
          })
          this.isShowEditForm = false
          this.$emit("success")
        })
        .catch(() => {
          this.$message({
            message: "Có lỗi xảy ra",
            type: "error",
          })
        })
    },
  },
}
</script>

<style scoped>
.checker-type-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}

.checker-type {
  width: 180px;
  margin-right: 10px;
}

.el-form-item__content .checker-type-container .el-input-group {
  margin: 0 0 8px 0;
  color: #8d9094;
  width: calc(100% - 180px - 10px);
  min-width: 260px;
}

label.el-form-item__label {
  font-size: 18px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.el-form-item__content .el-input-group {
  margin-top: 10px;
}

.icon {
  color: darkorange;
  cursor: pointer;
}

.icon.disabled-icon {
  color: gray;
  opacity: 0.5;
  cursor: default;
}
</style>
